/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestrictedOperation = exports.ReplacementType = exports.Region = exports.PurchaseType = exports.PurchaseCycle = exports.PrimitiveType = exports.PluginInterface = exports.PlanStatus = exports.PlanDescription = exports.PermittedRoleType = exports.PartialPaymentRestriction = exports.OpenConsentIn = exports.NavigationType = exports.MediaType = exports.MediaMimeType = exports.MeasurementSystem = exports.MandatoryField = exports.LockableOperation = exports.ListEventFromCalendars = exports.InstallPage = exports.InitDirection = exports.HostContainerId = exports.HorizontalDocking = exports.HookType = exports.ExtensionType = exports.ExtendingComponentType = exports.ExecutionType = exports.EmbeddedScriptPlacement = exports.EmbeddedScriptPages = exports.EmbedCategory = exports.ElementType = exports.DependencyData = exports.DefaultTextStyle = exports.Default = exports.ConnectMethod = exports.ComponentType = exports.ComponentPresent = exports.Classification = exports.ChannelType = exports.CalendarType = exports.BusinessModel = exports.BarAlignmentSelected = exports.BackOfficeScriptAssetType = exports.BackOfficeHostingPlatforms = exports.ApplicationAutomationComponentStatus = exports.ApiStatus = exports.ApiExposure = exports.AlgorithmType = exports.AcceptedSmsMessageType = exports.AcceptedDirectMessageType = void 0;
exports.WidgetWidthType = exports.WidgetVertical = exports.WidgetHorizontal = exports.ViewMode = exports.VerticalDocking = exports.VersionType = exports.VersionStatus = exports.UnitType = exports.UninstallActions = exports.Type = exports.TranslationType = exports.ThumbnailsSize = exports.TextInputDisplayType = exports.TemplateDefaultColor = exports.Tag = exports.SyncToCalendar = exports.State = exports.SimpleType = exports.ScriptType = exports.SchemaFieldExposure = exports.RoleType = void 0;
var AcceptedDirectMessageType;
(function (AcceptedDirectMessageType) {
    AcceptedDirectMessageType["TEXT"] = "TEXT";
    AcceptedDirectMessageType["MEDIA"] = "MEDIA";
    AcceptedDirectMessageType["CARD"] = "CARD";
    AcceptedDirectMessageType["ANNOUNCEMENT"] = "ANNOUNCEMENT";
    AcceptedDirectMessageType["FORM"] = "FORM";
})(AcceptedDirectMessageType = exports.AcceptedDirectMessageType || (exports.AcceptedDirectMessageType = {}));
var AcceptedSmsMessageType;
(function (AcceptedSmsMessageType) {
    AcceptedSmsMessageType["SMS"] = "SMS";
    AcceptedSmsMessageType["MMS"] = "MMS";
})(AcceptedSmsMessageType = exports.AcceptedSmsMessageType || (exports.AcceptedSmsMessageType = {}));
var AlgorithmType;
(function (AlgorithmType) {
    AlgorithmType["UNSPECIFIED"] = "UNSPECIFIED";
    AlgorithmType["RELATED_ITEMS"] = "RELATED_ITEMS";
    AlgorithmType["GLOBAL"] = "GLOBAL";
})(AlgorithmType = exports.AlgorithmType || (exports.AlgorithmType = {}));
var ApiExposure;
(function (ApiExposure) {
    ApiExposure["NONE_EXPOSURE"] = "NONE_EXPOSURE";
    ApiExposure["PRIVATE_EXPOSURE"] = "PRIVATE_EXPOSURE";
    ApiExposure["INTERNAL_EXPOSURE"] = "INTERNAL_EXPOSURE";
    ApiExposure["PUBLIC_EXPOSURE"] = "PUBLIC_EXPOSURE";
})(ApiExposure = exports.ApiExposure || (exports.ApiExposure = {}));
var ApiStatus;
(function (ApiStatus) {
    ApiStatus["NONE_EXTENSION_STATUS"] = "NONE_EXTENSION_STATUS";
    ApiStatus["INTERNAL"] = "INTERNAL";
    ApiStatus["EXTERNAL"] = "EXTERNAL";
})(ApiStatus = exports.ApiStatus || (exports.ApiStatus = {}));
var ApplicationAutomationComponentStatus;
(function (ApplicationAutomationComponentStatus) {
    ApplicationAutomationComponentStatus["ACTIVE"] = "ACTIVE";
    ApplicationAutomationComponentStatus["INACTIVE"] = "INACTIVE";
})(ApplicationAutomationComponentStatus = exports.ApplicationAutomationComponentStatus || (exports.ApplicationAutomationComponentStatus = {}));
var BackOfficeHostingPlatforms;
(function (BackOfficeHostingPlatforms) {
    BackOfficeHostingPlatforms["NO_HOSTING_PLATFORM"] = "NO_HOSTING_PLATFORM";
    BackOfficeHostingPlatforms["BUSINESS_MANAGER"] = "BUSINESS_MANAGER";
    BackOfficeHostingPlatforms["ACCOUNT_MANAGER"] = "ACCOUNT_MANAGER";
    BackOfficeHostingPlatforms["DEV_CENTER"] = "DEV_CENTER";
    BackOfficeHostingPlatforms["ENTERPRISE"] = "ENTERPRISE";
    BackOfficeHostingPlatforms["PARTNERS_DASHBOARD"] = "PARTNERS_DASHBOARD";
    BackOfficeHostingPlatforms["FINANCIALS_INTERNAL_BO"] = "FINANCIALS_INTERNAL_BO";
    BackOfficeHostingPlatforms["FED_GUILD_POC"] = "FED_GUILD_POC";
    BackOfficeHostingPlatforms["STUDIO_DASHBOARD"] = "STUDIO_DASHBOARD";
})(BackOfficeHostingPlatforms = exports.BackOfficeHostingPlatforms || (exports.BackOfficeHostingPlatforms = {}));
var BackOfficeScriptAssetType;
(function (BackOfficeScriptAssetType) {
    BackOfficeScriptAssetType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    BackOfficeScriptAssetType["MODULE"] = "MODULE";
})(BackOfficeScriptAssetType = exports.BackOfficeScriptAssetType || (exports.BackOfficeScriptAssetType = {}));
var BarAlignmentSelected;
(function (BarAlignmentSelected) {
    BarAlignmentSelected["ALIGN_LEFT"] = "ALIGN_LEFT";
    BarAlignmentSelected["ALIGN_CENTER"] = "ALIGN_CENTER";
    BarAlignmentSelected["ALIGN_RIGHT"] = "ALIGN_RIGHT";
})(BarAlignmentSelected = exports.BarAlignmentSelected || (exports.BarAlignmentSelected = {}));
var BusinessModel;
(function (BusinessModel) {
    BusinessModel["None"] = "None";
    BusinessModel["FREEMIUM"] = "FREEMIUM";
    BusinessModel["PREMIUM"] = "PREMIUM";
    BusinessModel["FREE"] = "FREE";
    BusinessModel["WIX_PREMIUM"] = "WIX_PREMIUM";
    BusinessModel["DYNAMIC"] = "DYNAMIC";
})(BusinessModel = exports.BusinessModel || (exports.BusinessModel = {}));
var CalendarType;
(function (CalendarType) {
    CalendarType["UNDEFINED"] = "UNDEFINED";
    CalendarType["GOOGLE"] = "GOOGLE";
    CalendarType["I_CAL"] = "I_CAL";
    CalendarType["MICROSOFT"] = "MICROSOFT";
    CalendarType["OTHER"] = "OTHER";
})(CalendarType = exports.CalendarType || (exports.CalendarType = {}));
var ChannelType;
(function (ChannelType) {
    ChannelType["UNKNOWN_CHANNEL_TYPE"] = "UNKNOWN_CHANNEL_TYPE";
    ChannelType["DIRECT_MESSAGING"] = "DIRECT_MESSAGING";
    ChannelType["EMAIL"] = "EMAIL";
    ChannelType["SMS"] = "SMS";
})(ChannelType = exports.ChannelType || (exports.ChannelType = {}));
var Classification;
(function (Classification) {
    Classification["SITE_APP"] = "SITE_APP";
    Classification["API_KEY"] = "API_KEY";
    Classification["VELO_APP"] = "VELO_APP";
    Classification["PRIVATE_APP"] = "PRIVATE_APP";
    Classification["HEADLESS"] = "HEADLESS";
})(Classification = exports.Classification || (exports.Classification = {}));
var ComponentPresent;
(function (ComponentPresent) {
    ComponentPresent["NONE_PRESENT"] = "NONE_PRESENT";
    ComponentPresent["EDITOR_PRESENT"] = "EDITOR_PRESENT";
    ComponentPresent["DASHBOARD_PRESENT"] = "DASHBOARD_PRESENT";
    ComponentPresent["EXTENSION_PRESENT"] = "EXTENSION_PRESENT";
})(ComponentPresent = exports.ComponentPresent || (exports.ComponentPresent = {}));
var ComponentType;
(function (ComponentType) {
    ComponentType["NONE"] = "NONE";
    ComponentType["STUDIO"] = "STUDIO";
    ComponentType["PLATFORM"] = "PLATFORM";
    ComponentType["WORKER"] = "WORKER";
    ComponentType["DASHBOARD"] = "DASHBOARD";
    ComponentType["WIDGET"] = "WIDGET";
    ComponentType["PAGE"] = "PAGE";
    ComponentType["DASHBOARD_PLATFORM"] = "DASHBOARD_PLATFORM";
    ComponentType["STUDIO_WIDGET"] = "STUDIO_WIDGET";
    ComponentType["EMBEDDED_SCRIPT"] = "EMBEDDED_SCRIPT";
    ComponentType["EXTENSION"] = "EXTENSION";
    ComponentType["SNIPPET_SOLUTION"] = "SNIPPET_SOLUTION";
    ComponentType["DATA_COMPONENT"] = "DATA_COMPONENT";
    ComponentType["WEB"] = "WEB";
    ComponentType["DC_CONFIG"] = "DC_CONFIG";
    ComponentType["WIDGET_OUT_OF_IFRAME"] = "WIDGET_OUT_OF_IFRAME";
    ComponentType["PAGE_OUT_OF_IFRAME"] = "PAGE_OUT_OF_IFRAME";
    ComponentType["STATIC_FILE"] = "STATIC_FILE";
    ComponentType["APP_CONFIG"] = "APP_CONFIG";
    ComponentType["MULTIPLE_DASHBOARDS"] = "MULTIPLE_DASHBOARDS";
    ComponentType["PAYMENTS_GATEWAY"] = "PAYMENTS_GATEWAY";
    ComponentType["CODE_PACKAGE"] = "CODE_PACKAGE";
    ComponentType["AUTOMATION_TRIGGER"] = "AUTOMATION_TRIGGER";
    ComponentType["INVOICES_ACTIONS"] = "INVOICES_ACTIONS";
    ComponentType["DASHBOARD_APPLICATION"] = "DASHBOARD_APPLICATION";
    ComponentType["CONTACT_LABELS"] = "CONTACT_LABELS";
    ComponentType["WIDGET_PLUGIN"] = "WIDGET_PLUGIN";
    ComponentType["CROSS_SELL"] = "CROSS_SELL";
    ComponentType["LOCAL_DELIVERY"] = "LOCAL_DELIVERY";
    ComponentType["PAYMENT_PROVIDER"] = "PAYMENT_PROVIDER";
    ComponentType["ECOM_MEMBERSHIPS"] = "ECOM_MEMBERSHIPS";
    ComponentType["ECOM_LINE_ITEMS_ENRICHER"] = "ECOM_LINE_ITEMS_ENRICHER";
    ComponentType["ECOM_SHIPPING_RATES"] = "ECOM_SHIPPING_RATES";
    ComponentType["SHIPPING_LABEL_CARRIER"] = "SHIPPING_LABEL_CARRIER";
    ComponentType["RESTAURANTS_POS"] = "RESTAURANTS_POS";
    ComponentType["FICTIONAL_SHIPPING_PROVIDER"] = "FICTIONAL_SHIPPING_PROVIDER";
    ComponentType["ALERT_ENRICHER"] = "ALERT_ENRICHER";
    ComponentType["DATA_EXTENSIONS"] = "DATA_EXTENSIONS";
    ComponentType["GENERIC_HOOKS"] = "GENERIC_HOOKS";
    ComponentType["AUTOMATIONS_ACTION_PROVIDER"] = "AUTOMATIONS_ACTION_PROVIDER";
    ComponentType["ECOM_CATALOG"] = "ECOM_CATALOG";
    ComponentType["BACK_OFFICE_EXTENSION_CONTAINER"] = "BACK_OFFICE_EXTENSION_CONTAINER";
    ComponentType["BACK_OFFICE_EXTENSION"] = "BACK_OFFICE_EXTENSION";
    ComponentType["AUTOMATIONS_TRIGGER_PROVIDER"] = "AUTOMATIONS_TRIGGER_PROVIDER";
    ComponentType["IDENTITY_PRE_REGISTRATION"] = "IDENTITY_PRE_REGISTRATION";
    ComponentType["PREMIUM_PRODUCTS_PATHS"] = "PREMIUM_PRODUCTS_PATHS";
    ComponentType["ECOM_CUSTOM_SCOPE"] = "ECOM_CUSTOM_SCOPE";
    ComponentType["GIFT_CARDS_PROVIDER"] = "GIFT_CARDS_PROVIDER";
    ComponentType["DEALER_EXTERNAL_FILTER_PROVIDER"] = "DEALER_EXTERNAL_FILTER_PROVIDER";
    ComponentType["ECOM_DROPSHIPPING_PROVIDER"] = "ECOM_DROPSHIPPING_PROVIDER";
    ComponentType["INVOICES_PROVIDER"] = "INVOICES_PROVIDER";
    ComponentType["SEO_KEYWORDS_SUGGESTIONS"] = "SEO_KEYWORDS_SUGGESTIONS";
    ComponentType["ECOM_DISCOUNTS_TRIGGER"] = "ECOM_DISCOUNTS_TRIGGER";
    ComponentType["MULTILINGUAL_CONTENT_PROVIDER"] = "MULTILINGUAL_CONTENT_PROVIDER";
    ComponentType["APPLICATION_AUTOMATION"] = "APPLICATION_AUTOMATION";
    ComponentType["BACK_OFFICE_SIDEBAR_CATEGORY"] = "BACK_OFFICE_SIDEBAR_CATEGORY";
    ComponentType["BACK_OFFICE_PAGE"] = "BACK_OFFICE_PAGE";
    ComponentType["ECOM_ADDITIONAL_FEES"] = "ECOM_ADDITIONAL_FEES";
    ComponentType["PING_USER_NOTIFICATION"] = "PING_USER_NOTIFICATION";
    ComponentType["ECOM_RECOMMENDATIONS_PROVIDER"] = "ECOM_RECOMMENDATIONS_PROVIDER";
    ComponentType["BOOKINGS_PRICING_PROVIDER"] = "BOOKINGS_PRICING_PROVIDER";
    ComponentType["IDENTITY_AUTHENTICATOR"] = "IDENTITY_AUTHENTICATOR";
    ComponentType["IDENTITY_IDP_CONNECTOR"] = "IDENTITY_IDP_CONNECTOR";
    ComponentType["ITEMS_SELECTION_PROVIDER"] = "ITEMS_SELECTION_PROVIDER";
    ComponentType["PORTFOLIO_SYNCED_PROJECTS_PROVIDER"] = "PORTFOLIO_SYNCED_PROJECTS_PROVIDER";
    ComponentType["COMMUNICATION_CHANNEL"] = "COMMUNICATION_CHANNEL";
    ComponentType["IDENTITY_POST_LOGIN"] = "IDENTITY_POST_LOGIN";
    ComponentType["BACK_OFFICE_WIDGET"] = "BACK_OFFICE_WIDGET";
    ComponentType["SOCIAL_MARKETING_DESIGN"] = "SOCIAL_MARKETING_DESIGN";
    ComponentType["FORMS_SUBMISSIONS_PROVIDER"] = "FORMS_SUBMISSIONS_PROVIDER";
    ComponentType["WIX_OFFERING"] = "WIX_OFFERING";
    ComponentType["DEV_CENTER_TESTING_COMPONENT"] = "DEV_CENTER_TESTING_COMPONENT";
    ComponentType["COMPONENTS_VALIDATOR_PROVIDER"] = "COMPONENTS_VALIDATOR_PROVIDER";
    ComponentType["COMPONENTS_TRANSLATIONS_ADDITIONAL_FIELDS_PROVIDER"] = "COMPONENTS_TRANSLATIONS_ADDITIONAL_FIELDS_PROVIDER";
    ComponentType["FORMS_SCHEMA_PROVIDER"] = "FORMS_SCHEMA_PROVIDER";
    ComponentType["BOOKINGS_EXTERNAL_CALENDAR_PROVIDER"] = "BOOKINGS_EXTERNAL_CALENDAR_PROVIDER";
    ComponentType["ECOM_DEFAULT_TAXATION_CATEGORY"] = "ECOM_DEFAULT_TAXATION_CATEGORY";
    ComponentType["VIEWER_DYNAMIC_SITE_STRUCTURE_PROVIDER"] = "VIEWER_DYNAMIC_SITE_STRUCTURE_PROVIDER";
    ComponentType["PING_UOU_NOTIFICATION"] = "PING_UOU_NOTIFICATION";
    ComponentType["HEADLESS_OAUTH"] = "HEADLESS_OAUTH";
    ComponentType["ECOM_TAX_CALCULATOR_SPI"] = "ECOM_TAX_CALCULATOR_SPI";
    ComponentType["ENTITLEMENT_PROVIDER"] = "ENTITLEMENT_PROVIDER";
    ComponentType["COMMENTS_MODERATION_PROVIDER"] = "COMMENTS_MODERATION_PROVIDER";
    ComponentType["GRID_APP_FILES_TRANSFORMER"] = "GRID_APP_FILES_TRANSFORMER";
    ComponentType["ENTITLEMENT_POLICY_PROVIDER"] = "ENTITLEMENT_POLICY_PROVIDER";
    ComponentType["PREMIUM_CUSTOM_CHARGES"] = "PREMIUM_CUSTOM_CHARGES";
    ComponentType["ECOM_VALIDATIONS"] = "ECOM_VALIDATIONS";
    ComponentType["COMPONENT_REFERENCE_DATA_PROVIDER"] = "COMPONENT_REFERENCE_DATA_PROVIDER";
    ComponentType["WIX_REVIEWS_PRODUCT_CATALOG"] = "WIX_REVIEWS_PRODUCT_CATALOG";
    ComponentType["SOCIAL_MARKETING_DESIGNS_PROVIDER"] = "SOCIAL_MARKETING_DESIGNS_PROVIDER";
    ComponentType["GOOGLE_BUSINESS_PROFILE_FEATURE_PROVIDER"] = "GOOGLE_BUSINESS_PROFILE_FEATURE_PROVIDER";
    ComponentType["COMMENTS_FILTER_PROVIDER"] = "COMMENTS_FILTER_PROVIDER";
    ComponentType["BILLING_TAX_ID_VALIDATOR"] = "BILLING_TAX_ID_VALIDATOR";
    ComponentType["PING_SETTINGS_GROUP"] = "PING_SETTINGS_GROUP";
    ComponentType["FORMS_SPAM_SUBMISSIONS_PROVIDER"] = "FORMS_SPAM_SUBMISSIONS_PROVIDER";
    ComponentType["EDITOR_ADDON"] = "EDITOR_ADDON";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
var ConnectMethod;
(function (ConnectMethod) {
    ConnectMethod["OAUTH"] = "OAUTH";
    ConnectMethod["CREDENTIALS"] = "CREDENTIALS";
})(ConnectMethod = exports.ConnectMethod || (exports.ConnectMethod = {}));
var Default;
(function (Default) {
    Default["WIX"] = "WIX";
    Default["POS"] = "POS";
})(Default = exports.Default || (exports.Default = {}));
var DefaultTextStyle;
(function (DefaultTextStyle) {
    DefaultTextStyle["TITLE"] = "TITLE";
    DefaultTextStyle["PARAGRAPH"] = "PARAGRAPH";
    DefaultTextStyle["LOWER_HIERARCHY_TEXTS"] = "LOWER_HIERARCHY_TEXTS";
})(DefaultTextStyle = exports.DefaultTextStyle || (exports.DefaultTextStyle = {}));
var DependencyData;
(function (DependencyData) {
    DependencyData["PROVISION_ONLY_INSTALLATION"] = "PROVISION_ONLY_INSTALLATION";
    DependencyData["NOTIFY_USER_ON_DEPENDENCY"] = "NOTIFY_USER_ON_DEPENDENCY";
    DependencyData["IS_BUNDLE"] = "IS_BUNDLE";
})(DependencyData = exports.DependencyData || (exports.DependencyData = {}));
var ElementType;
(function (ElementType) {
    ElementType["WIDGET"] = "WIDGET";
    ElementType["PAGE"] = "PAGE";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
var EmbedCategory;
(function (EmbedCategory) {
    EmbedCategory["UNKNOWN"] = "UNKNOWN";
    EmbedCategory["ESSENTIAL"] = "ESSENTIAL";
    EmbedCategory["FUNCTIONAL"] = "FUNCTIONAL";
    EmbedCategory["ANALYTICS"] = "ANALYTICS";
    EmbedCategory["ADVERTISING"] = "ADVERTISING";
})(EmbedCategory = exports.EmbedCategory || (exports.EmbedCategory = {}));
var EmbeddedScriptPages;
(function (EmbeddedScriptPages) {
    EmbeddedScriptPages["NONE_PAGES"] = "NONE_PAGES";
    EmbeddedScriptPages["ONCE"] = "ONCE";
    EmbeddedScriptPages["SPECIFIC_PAGES"] = "SPECIFIC_PAGES";
})(EmbeddedScriptPages = exports.EmbeddedScriptPages || (exports.EmbeddedScriptPages = {}));
var EmbeddedScriptPlacement;
(function (EmbeddedScriptPlacement) {
    EmbeddedScriptPlacement["NONE_PLACEMENT"] = "NONE_PLACEMENT";
    EmbeddedScriptPlacement["HEAD"] = "HEAD";
    EmbeddedScriptPlacement["BODY_START"] = "BODY_START";
    EmbeddedScriptPlacement["BODY_END"] = "BODY_END";
})(EmbeddedScriptPlacement = exports.EmbeddedScriptPlacement || (exports.EmbeddedScriptPlacement = {}));
var ExecutionType;
(function (ExecutionType) {
    ExecutionType["UNKNOWN_EXECUTION_TYPE"] = "UNKNOWN_EXECUTION_TYPE";
    ExecutionType["SYNC"] = "SYNC";
    ExecutionType["ASYNC"] = "ASYNC";
})(ExecutionType = exports.ExecutionType || (exports.ExecutionType = {}));
var ExtendingComponentType;
(function (ExtendingComponentType) {
    ExtendingComponentType["INVALID"] = "INVALID";
    ExtendingComponentType["BACK_OFFICE_MENU_ITEM"] = "BACK_OFFICE_MENU_ITEM";
    ExtendingComponentType["BACK_OFFICE_EXTENSION_WIDGET"] = "BACK_OFFICE_EXTENSION_WIDGET";
})(ExtendingComponentType = exports.ExtendingComponentType || (exports.ExtendingComponentType = {}));
var ExtensionType;
(function (ExtensionType) {
    ExtensionType["NONE_EXTENSION"] = "NONE_EXTENSION";
    ExtensionType["PAYMENTS_GATEWAY_EXTENSION"] = "PAYMENTS_GATEWAY_EXTENSION";
    ExtensionType["COUPONS_EXTENSION"] = "COUPONS_EXTENSION";
    ExtensionType["DROPSHIPPING_EXTENSION"] = "DROPSHIPPING_EXTENSION";
    ExtensionType["FULFILMENT_EXTENSION"] = "FULFILMENT_EXTENSION";
    ExtensionType["DROPSHIPPING_SUPPLIER_EXTENSION"] = "DROPSHIPPING_SUPPLIER_EXTENSION";
    ExtensionType["FULFILLMENT_CENTER_EXTENSION"] = "FULFILLMENT_CENTER_EXTENSION";
    ExtensionType["RESTAURANTS_POS_EXTENSION"] = "RESTAURANTS_POS_EXTENSION";
    ExtensionType["ART_STORE_EXTENSION"] = "ART_STORE_EXTENSION";
    ExtensionType["ASCEND_AUTOMATION_EXTENSION"] = "ASCEND_AUTOMATION_EXTENSION";
    ExtensionType["CONTACT_LABELS_EXTENSION"] = "CONTACT_LABELS_EXTENSION";
})(ExtensionType = exports.ExtensionType || (exports.ExtensionType = {}));
var HookType;
(function (HookType) {
    HookType["UNDEFINED"] = "UNDEFINED";
    HookType["BEFORE_BLOCKING"] = "BEFORE_BLOCKING";
    HookType["BEFORE"] = "BEFORE";
    HookType["AFTER"] = "AFTER";
})(HookType = exports.HookType || (exports.HookType = {}));
var HorizontalDocking;
(function (HorizontalDocking) {
    HorizontalDocking["NO_HDOCKING"] = "NO_HDOCKING";
    HorizontalDocking["LEFT_DOCKING"] = "LEFT_DOCKING";
    HorizontalDocking["HCENTER"] = "HCENTER";
    HorizontalDocking["RIGHT_DOCKING"] = "RIGHT_DOCKING";
})(HorizontalDocking = exports.HorizontalDocking || (exports.HorizontalDocking = {}));
var HostContainerId;
(function (HostContainerId) {
    HostContainerId["BUSINESS_MANAGER"] = "BUSINESS_MANAGER";
    HostContainerId["BUSINESS_DASHBOARD_HOST"] = "BUSINESS_DASHBOARD_HOST";
    HostContainerId["SIDEBAR_FOOTER"] = "SIDEBAR_FOOTER";
})(HostContainerId = exports.HostContainerId || (exports.HostContainerId = {}));
var InitDirection;
(function (InitDirection) {
    InitDirection["UNKNOWN_INIT_DIRECTION"] = "UNKNOWN_INIT_DIRECTION";
    InitDirection["BUSINESS"] = "BUSINESS";
    InitDirection["CUSTOMER"] = "CUSTOMER";
    InitDirection["BOTH"] = "BOTH";
})(InitDirection = exports.InitDirection || (exports.InitDirection = {}));
var InstallPage;
(function (InstallPage) {
    InstallPage["NO_PAGE"] = "NO_PAGE";
    InstallPage["CURRENT"] = "CURRENT";
    InstallPage["PAGE"] = "PAGE";
    InstallPage["LIGHTBOX"] = "LIGHTBOX";
})(InstallPage = exports.InstallPage || (exports.InstallPage = {}));
var ListEventFromCalendars;
(function (ListEventFromCalendars) {
    ListEventFromCalendars["LIST_NOT_SUPPORTED"] = "LIST_NOT_SUPPORTED";
    ListEventFromCalendars["LIST_FROM_PRIMARY_CALENDAR_ONLY"] = "LIST_FROM_PRIMARY_CALENDAR_ONLY";
    ListEventFromCalendars["LIST_FROM_SPECIFIC_CALENDARS"] = "LIST_FROM_SPECIFIC_CALENDARS";
})(ListEventFromCalendars = exports.ListEventFromCalendars || (exports.ListEventFromCalendars = {}));
var LockableOperation;
(function (LockableOperation) {
    LockableOperation["UNSPECIFIED_LOCKABLE"] = "UNSPECIFIED_LOCKABLE";
    LockableOperation["LOCKED"] = "LOCKED";
    LockableOperation["UNLOCKED"] = "UNLOCKED";
})(LockableOperation = exports.LockableOperation || (exports.LockableOperation = {}));
var MandatoryField;
(function (MandatoryField) {
    MandatoryField["ZIPCODE"] = "ZIPCODE";
    MandatoryField["CITY"] = "CITY";
    MandatoryField["STATE"] = "STATE";
    MandatoryField["ADDRESS"] = "ADDRESS";
    MandatoryField["COUNTRY_CODE"] = "COUNTRY_CODE";
    MandatoryField["EMAIL"] = "EMAIL";
    MandatoryField["PHONE"] = "PHONE";
    MandatoryField["FIRST_NAME"] = "FIRST_NAME";
    MandatoryField["LAST_NAME"] = "LAST_NAME";
    MandatoryField["STREET"] = "STREET";
    MandatoryField["HOUSE_NUMBER"] = "HOUSE_NUMBER";
    MandatoryField["TAX_IDENTIFIER"] = "TAX_IDENTIFIER";
})(MandatoryField = exports.MandatoryField || (exports.MandatoryField = {}));
var MeasurementSystem;
(function (MeasurementSystem) {
    MeasurementSystem["Metric"] = "Metric";
    MeasurementSystem["Imperial"] = "Imperial";
})(MeasurementSystem = exports.MeasurementSystem || (exports.MeasurementSystem = {}));
var MediaMimeType;
(function (MediaMimeType) {
    MediaMimeType["UNKNOWN_MIME_TYPE"] = "UNKNOWN_MIME_TYPE";
    MediaMimeType["IMAGE_JPEG"] = "IMAGE_JPEG";
    MediaMimeType["IMAGE_PNG"] = "IMAGE_PNG";
    MediaMimeType["IMAGE_WEBP"] = "IMAGE_WEBP";
    MediaMimeType["VIDEO_MPEG"] = "VIDEO_MPEG";
    MediaMimeType["VIDEO_MP4"] = "VIDEO_MP4";
    MediaMimeType["VIDEO_3GP"] = "VIDEO_3GP";
    MediaMimeType["AUDIO_AAC"] = "AUDIO_AAC";
    MediaMimeType["AUDIO_MP4"] = "AUDIO_MP4";
    MediaMimeType["AUDIO_MPEG"] = "AUDIO_MPEG";
    MediaMimeType["AUDIO_OGG"] = "AUDIO_OGG";
    MediaMimeType["AUDIO_OPUS"] = "AUDIO_OPUS";
    MediaMimeType["APPLICATION_PDF"] = "APPLICATION_PDF";
    MediaMimeType["APPLICATION_OCTET_STREAM"] = "APPLICATION_OCTET_STREAM";
})(MediaMimeType = exports.MediaMimeType || (exports.MediaMimeType = {}));
var MediaType;
(function (MediaType) {
    MediaType["VIDEO"] = "VIDEO";
    MediaType["IMAGE"] = "IMAGE";
    MediaType["YOUTUBE"] = "YOUTUBE";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
var NavigationType;
(function (NavigationType) {
    NavigationType["NAVIGATE"] = "NAVIGATE";
    NavigationType["MODAL"] = "MODAL";
})(NavigationType = exports.NavigationType || (exports.NavigationType = {}));
var OpenConsentIn;
(function (OpenConsentIn) {
    OpenConsentIn["NONE_VALUE"] = "NONE_VALUE";
    OpenConsentIn["NEW_WINDOW"] = "NEW_WINDOW";
    OpenConsentIn["NEW_TAB"] = "NEW_TAB";
})(OpenConsentIn = exports.OpenConsentIn || (exports.OpenConsentIn = {}));
var PartialPaymentRestriction;
(function (PartialPaymentRestriction) {
    PartialPaymentRestriction["UNDEFINED"] = "UNDEFINED";
    PartialPaymentRestriction["ALLOW"] = "ALLOW";
    PartialPaymentRestriction["DISALLOW"] = "DISALLOW";
})(PartialPaymentRestriction = exports.PartialPaymentRestriction || (exports.PartialPaymentRestriction = {}));
var PermittedRoleType;
(function (PermittedRoleType) {
    PermittedRoleType["UNKNOWN_PERMITTED_ROLE_TYPE"] = "UNKNOWN_PERMITTED_ROLE_TYPE";
    PermittedRoleType["APP_OWNER"] = "APP_OWNER";
    PermittedRoleType["TEAM_MEMBER"] = "TEAM_MEMBER";
    PermittedRoleType["APP_MARKET_EMPLOYEE"] = "APP_MARKET_EMPLOYEE";
    PermittedRoleType["APP_MARKET_QA"] = "APP_MARKET_QA";
    PermittedRoleType["BLOCKS_QA"] = "BLOCKS_QA";
})(PermittedRoleType = exports.PermittedRoleType || (exports.PermittedRoleType = {}));
var PlanDescription;
(function (PlanDescription) {
    PlanDescription["UNKNOWN_DESCRIPTION"] = "UNKNOWN_DESCRIPTION";
    PlanDescription["BENEFITS"] = "BENEFITS";
    PlanDescription["CUSTOM_TEXT"] = "CUSTOM_TEXT";
})(PlanDescription = exports.PlanDescription || (exports.PlanDescription = {}));
var PlanStatus;
(function (PlanStatus) {
    PlanStatus["UNKNOWN"] = "UNKNOWN";
    PlanStatus["VISIBLE"] = "VISIBLE";
    PlanStatus["HIDDEN"] = "HIDDEN";
})(PlanStatus = exports.PlanStatus || (exports.PlanStatus = {}));
var PluginInterface;
(function (PluginInterface) {
    PluginInterface["NONE_INTERFACE"] = "NONE_INTERFACE";
    PluginInterface["DEFAULT"] = "DEFAULT";
    PluginInterface["RESOURCE"] = "RESOURCE";
    PluginInterface["REVIEWS"] = "REVIEWS";
    PluginInterface["RATINGS_SUMMARY"] = "RATINGS_SUMMARY";
    PluginInterface["ENV"] = "ENV";
    PluginInterface["RATINGS_SUMMARY_OOI_LIST"] = "RATINGS_SUMMARY_OOI_LIST";
    PluginInterface["BOOKINGS_SERVICE"] = "BOOKINGS_SERVICE";
})(PluginInterface = exports.PluginInterface || (exports.PluginInterface = {}));
var PrimitiveType;
(function (PrimitiveType) {
    PrimitiveType["UNKNOWN_PRIMITIVE_TYPE"] = "UNKNOWN_PRIMITIVE_TYPE";
    PrimitiveType["TEXT"] = "TEXT";
    PrimitiveType["BOOLEAN"] = "BOOLEAN";
    PrimitiveType["NUMBER"] = "NUMBER";
})(PrimitiveType = exports.PrimitiveType || (exports.PrimitiveType = {}));
var PurchaseCycle;
(function (PurchaseCycle) {
    PurchaseCycle["NO_CYCLE"] = "NO_CYCLE";
    PurchaseCycle["MONTHLY"] = "MONTHLY";
})(PurchaseCycle = exports.PurchaseCycle || (exports.PurchaseCycle = {}));
var PurchaseType;
(function (PurchaseType) {
    PurchaseType["NO_TYPE"] = "NO_TYPE";
    PurchaseType["RENEWAL"] = "RENEWAL";
})(PurchaseType = exports.PurchaseType || (exports.PurchaseType = {}));
var Region;
(function (Region) {
    Region["no_region"] = "no_region";
    Region["header"] = "header";
    Region["pageContainer"] = "pageContainer";
    Region["footer"] = "footer";
})(Region = exports.Region || (exports.Region = {}));
var ReplacementType;
(function (ReplacementType) {
    ReplacementType["UNKNOWN_REPLACEMENT"] = "UNKNOWN_REPLACEMENT";
    ReplacementType["REPLACING"] = "REPLACING";
    ReplacementType["REPLACEABLE"] = "REPLACEABLE";
})(ReplacementType = exports.ReplacementType || (exports.ReplacementType = {}));
var RestrictedOperation;
(function (RestrictedOperation) {
    RestrictedOperation["UNSPECIFIED_RESTRICTED"] = "UNSPECIFIED_RESTRICTED";
    RestrictedOperation["ALLOW"] = "ALLOW";
    RestrictedOperation["WARN"] = "WARN";
})(RestrictedOperation = exports.RestrictedOperation || (exports.RestrictedOperation = {}));
var RoleType;
(function (RoleType) {
    RoleType["NO_ROLE"] = "NO_ROLE";
    RoleType["OWNER"] = "OWNER";
    RoleType["DEVELOPER"] = "DEVELOPER";
    RoleType["ADMIN"] = "ADMIN";
    RoleType["GOD"] = "GOD";
})(RoleType = exports.RoleType || (exports.RoleType = {}));
var SchemaFieldExposure;
(function (SchemaFieldExposure) {
    SchemaFieldExposure["UNKNOWN_EXPOSURE"] = "UNKNOWN_EXPOSURE";
    SchemaFieldExposure["SETUP"] = "SETUP";
    SchemaFieldExposure["HIDDEN"] = "HIDDEN";
    SchemaFieldExposure["EXPOSED"] = "EXPOSED";
})(SchemaFieldExposure = exports.SchemaFieldExposure || (exports.SchemaFieldExposure = {}));
var ScriptType;
(function (ScriptType) {
    ScriptType["NO_SCRIPT_TYPE"] = "NO_SCRIPT_TYPE";
    ScriptType["MODULE"] = "MODULE";
})(ScriptType = exports.ScriptType || (exports.ScriptType = {}));
var SimpleType;
(function (SimpleType) {
    SimpleType["UNKNOWN_SIMPLE_TYPE"] = "UNKNOWN_SIMPLE_TYPE";
    SimpleType["MONEY"] = "MONEY";
    SimpleType["LINK"] = "LINK";
    SimpleType["BACKOFFICE_LINK"] = "BACKOFFICE_LINK";
    SimpleType["LIVESITE_LINK"] = "LIVESITE_LINK";
    SimpleType["MULTILINGUAL"] = "MULTILINGUAL";
    SimpleType["IMAGE_LINK"] = "IMAGE_LINK";
    SimpleType["GUID"] = "GUID";
    SimpleType["EMAIL"] = "EMAIL";
    SimpleType["PHONE"] = "PHONE";
    SimpleType["CONTACT_ID"] = "CONTACT_ID";
})(SimpleType = exports.SimpleType || (exports.SimpleType = {}));
var State;
(function (State) {
    State["UNKNOWN_STATE"] = "UNKNOWN_STATE";
    State["DEFAULT_ON"] = "DEFAULT_ON";
    State["DEFAULT_OFF"] = "DEFAULT_OFF";
    State["ALWAYS_ON"] = "ALWAYS_ON";
})(State = exports.State || (exports.State = {}));
var SyncToCalendar;
(function (SyncToCalendar) {
    SyncToCalendar["SYNC_NOT_SUPPORTED"] = "SYNC_NOT_SUPPORTED";
    SyncToCalendar["SYNC_TO_PRIMARY_CALENDAR_ONLY"] = "SYNC_TO_PRIMARY_CALENDAR_ONLY";
    SyncToCalendar["SYNC_TO_DEDICATED_CALENDAR"] = "SYNC_TO_DEDICATED_CALENDAR";
})(SyncToCalendar = exports.SyncToCalendar || (exports.SyncToCalendar = {}));
var Tag;
(function (Tag) {
    Tag["UNKNOWN_TAG"] = "UNKNOWN_TAG";
    Tag["EMBEDDABLE"] = "EMBEDDABLE";
    Tag["ECOM_EDIT_ORDER"] = "ECOM_EDIT_ORDER";
})(Tag = exports.Tag || (exports.Tag = {}));
var TemplateDefaultColor;
(function (TemplateDefaultColor) {
    TemplateDefaultColor["BACKGROUND"] = "BACKGROUND";
    TemplateDefaultColor["SECONDARY_TEXTS"] = "SECONDARY_TEXTS";
    TemplateDefaultColor["MAIN_TEXT_AND_ICONS"] = "MAIN_TEXT_AND_ICONS";
    TemplateDefaultColor["BORDERS_AND_DIVIDERS"] = "BORDERS_AND_DIVIDERS";
    TemplateDefaultColor["BUTTONS_AND_LINKS"] = "BUTTONS_AND_LINKS";
})(TemplateDefaultColor = exports.TemplateDefaultColor || (exports.TemplateDefaultColor = {}));
var TextInputDisplayType;
(function (TextInputDisplayType) {
    TextInputDisplayType["TEXT"] = "TEXT";
    TextInputDisplayType["PASSWORD"] = "PASSWORD";
    TextInputDisplayType["CODE"] = "CODE";
})(TextInputDisplayType = exports.TextInputDisplayType || (exports.TextInputDisplayType = {}));
var ThumbnailsSize;
(function (ThumbnailsSize) {
    ThumbnailsSize["SMALL"] = "SMALL";
    ThumbnailsSize["MEDIUM"] = "MEDIUM";
    ThumbnailsSize["LARGE"] = "LARGE";
    ThumbnailsSize["XLARGE"] = "XLARGE";
})(ThumbnailsSize = exports.ThumbnailsSize || (exports.ThumbnailsSize = {}));
var TranslationType;
(function (TranslationType) {
    TranslationType["UNINITIALIZED"] = "UNINITIALIZED";
    TranslationType["COMPONENT"] = "COMPONENT";
})(TranslationType = exports.TranslationType || (exports.TranslationType = {}));
var Type;
(function (Type) {
    Type["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    Type["WIDGET_COMPONENT"] = "WIDGET_COMPONENT";
    Type["GENERIC"] = "GENERIC";
})(Type = exports.Type || (exports.Type = {}));
var UninstallActions;
(function (UninstallActions) {
    UninstallActions["NONE_ACTION"] = "NONE_ACTION";
    UninstallActions["NO_ACTION"] = "NO_ACTION";
    UninstallActions["REMOVE_ALL_PRODUCT"] = "REMOVE_ALL_PRODUCT";
    UninstallActions["SHIPPING_RATES_REGION"] = "SHIPPING_RATES_REGION";
})(UninstallActions = exports.UninstallActions || (exports.UninstallActions = {}));
var UnitType;
(function (UnitType) {
    UnitType["NO_UNIT"] = "NO_UNIT";
    UnitType["AUTO"] = "AUTO";
    UnitType["PX"] = "PX";
    UnitType["VH"] = "VH";
    UnitType["VW"] = "VW";
    UnitType["PERCENTAGE"] = "PERCENTAGE";
})(UnitType = exports.UnitType || (exports.UnitType = {}));
var VersionStatus;
(function (VersionStatus) {
    VersionStatus["NONE_STATUS"] = "NONE_STATUS";
    VersionStatus["DRAFT"] = "DRAFT";
    VersionStatus["SUBMITTED"] = "SUBMITTED";
    VersionStatus["IN_REVIEW"] = "IN_REVIEW";
    VersionStatus["APPROVED"] = "APPROVED";
    VersionStatus["PUBLISHED"] = "PUBLISHED";
    VersionStatus["DECLINED"] = "DECLINED";
    VersionStatus["ARCHIVED"] = "ARCHIVED";
    VersionStatus["HIDDEN"] = "HIDDEN";
    VersionStatus["RELEASED"] = "RELEASED";
})(VersionStatus = exports.VersionStatus || (exports.VersionStatus = {}));
var VersionType;
(function (VersionType) {
    VersionType["BUILD"] = "BUILD";
    VersionType["MINOR"] = "MINOR";
    VersionType["MAJOR"] = "MAJOR";
})(VersionType = exports.VersionType || (exports.VersionType = {}));
var VerticalDocking;
(function (VerticalDocking) {
    VerticalDocking["NO_VDOCKING"] = "NO_VDOCKING";
    VerticalDocking["TOP_DOCKING"] = "TOP_DOCKING";
    VerticalDocking["VCENTER"] = "VCENTER";
    VerticalDocking["BOTTOM_DOCKING"] = "BOTTOM_DOCKING";
})(VerticalDocking = exports.VerticalDocking || (exports.VerticalDocking = {}));
var ViewMode;
(function (ViewMode) {
    ViewMode["PAGE"] = "PAGE";
    ViewMode["MODAL"] = "MODAL";
})(ViewMode = exports.ViewMode || (exports.ViewMode = {}));
var WidgetHorizontal;
(function (WidgetHorizontal) {
    WidgetHorizontal["NONE_HORIZONTAL"] = "NONE_HORIZONTAL";
    WidgetHorizontal["LEFT"] = "LEFT";
    WidgetHorizontal["CENTER_HORIZONTAL"] = "CENTER_HORIZONTAL";
    WidgetHorizontal["RIGHT"] = "RIGHT";
})(WidgetHorizontal = exports.WidgetHorizontal || (exports.WidgetHorizontal = {}));
var WidgetVertical;
(function (WidgetVertical) {
    WidgetVertical["NONE_VERTICAL"] = "NONE_VERTICAL";
    WidgetVertical["TOP"] = "TOP";
    WidgetVertical["CENTER_VERTICAL"] = "CENTER_VERTICAL";
    WidgetVertical["BOTTOM"] = "BOTTOM";
})(WidgetVertical = exports.WidgetVertical || (exports.WidgetVertical = {}));
var WidgetWidthType;
(function (WidgetWidthType) {
    WidgetWidthType["NONE_TYPE"] = "NONE_TYPE";
    WidgetWidthType["CUSTOM"] = "CUSTOM";
    WidgetWidthType["FULL"] = "FULL";
})(WidgetWidthType = exports.WidgetWidthType || (exports.WidgetWidthType = {}));
//# sourceMappingURL=types.js.map